import { Node } from '@tiptap/core';

export const HeadlineImage = Node.create({
  name: 'headlineImage',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: element => element.querySelector('img')?.getAttribute('src') || null,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-headline-image]' }];
  },

  renderHTML({ node }) {
    const attrs = { 'data-headline-image': '' };
    if (!node.attrs.src) return ['div', attrs];
    return [
      'div',
      attrs,
      ['img', { src: node.attrs.src, width: '600', height: 'auto', style: 'display:block;margin:0 auto;width:100%;' }],
    ];
  },

  addNodeView() {
    return ({ node, getPos, editor }) => {
      const dom = document.createElement('div');
      dom.className = 'border border-purple-200 rounded-lg overflow-hidden my-3 whitespace-normal';
      dom.setAttribute('data-headline-image', '');

      const render = (src) => {
        dom.innerHTML = `
          <div class="flex items-center justify-between px-3 py-1.5 bg-purple-50 border-b border-purple-200">
            <div class="flex items-center gap-1.5 text-xs font-semibold text-purple-700 uppercase tracking-wide">
              <span>★</span><span>Headline Image</span>
            </div>
            <button type="button" class="text-xs text-gray-400 hover:text-red-500" data-remove>Remove</button>
          </div>
          <div class="bg-white p-3 flex justify-center" data-image-area>
            ${src
              ? `<img src="${src}" class="max-w-full block mx-auto" />`
              : `<div class="text-center text-gray-400 py-8 text-sm">Uploading…</div>`
            }
          </div>
        `;

        dom.querySelector('[data-remove]').addEventListener('mousedown', (e) => {
          e.preventDefault();
          const pos = typeof getPos === 'function' ? getPos() : null;
          if (pos !== null) {
            const current = editor.state.doc.nodeAt(pos);
            if (current) {
              editor.chain().focus().deleteRange({ from: pos, to: pos + current.nodeSize }).run();
            }
          }
        });
      };

      render(node.attrs.src);

      return {
        dom,
        update(updatedNode) {
          if (updatedNode.type.name !== 'headlineImage') return false;
          render(updatedNode.attrs.src);
          return true;
        },
      };
    };
  },

  addCommands() {
    return {
      insertHeadlineImage: (attrs = {}) => ({ chain }) => {
        return chain().insertContent({ type: this.name, attrs }).run();
      },
    };
  },
});

export const headlineImageSlashItem = {
  title: 'Headline Image',
  description: 'Set the featured image for this post',
  icon: '★',
  group: 'Media',
  keywords: ['headline', 'featured', 'cover', 'hero', 'image', 'photo', 'thumbnail'],
  command: ({ editor, range }) => {
    let existingHeadlineImagePos = null;
    editor.state.doc.forEach((node, offset) => {
      if (node.type.name === 'headlineImage' && existingHeadlineImagePos === null) {
        existingHeadlineImagePos = offset;
      }
    });

    editor.chain().focus().deleteRange(range).run();

    const controllerEl = editor.view.dom.closest('[data-controller~="tiptap"]');
    const controller = window.Stimulus.getControllerForElementAndIdentifier(controllerEl, 'tiptap');
    controller.initiateHeadlineImageUpload(existingHeadlineImagePos === null);
  },
};
